import React from "react";
import { toast } from "react-toastify";
import {
  Button,
  ButtonGroup,
  Container,
  Col,
  Table,
  Row,
  FormGroup,
  Label,
  Input,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormText,
} from "reactstrap";
import axios from "axios";
import numeral from "numeral";
import moment from "moment";
import { Link } from "react-router-dom";

const ReferenceMandates = (props) => {
  const [mandates, setMandates] = React.useState([]);
  const getrefmandates = async () => {
    try {
      const { data } = await axios.get(
        `/api/findrefmandates/${props.match.params.client}`,
        {
          headers: { Authorization: localStorage.getItem("token") },
        }
      );
      // console.log(data);
      setMandates(data);
    } catch (error) {
      console.log(error);
      toast("Could not process request");
    }
  };
  const stopreferencecollection = async (dataref) => {
    try {
      const { data } = await axios.post(
        `/api/stopreferencecollection/${dataref}`,
        {},
        { headers: { Authorization: localStorage.getItem("token") } }
      );
      toast("mandate stopped successfully");
      getrefmandates();
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        typeof error.response.data === "string"
      )
        toast.error(error.response.data);

      console.log(error);
      toast("Could not process request");
    }
  };

  const checkRepayment = async (dataref) => {
    try {
      const { data } = await axios.get(
        `/api/getReferenceRepayments/${dataref}`,
        { headers: { Authorization: localStorage.getItem("token") } }
      );
      let lines = "";

      if (data && Array.isArray(data)) {
        data.map((rep) => {
          lines += `Deduction Date - ${rep.deductiondate}\nAmount - ${rep.transactionamount}\nPayment Status - ${rep.paymentstatus}\n\n`;
        });
      }
      alert(lines);
      // toast('mandate stopped successfully');
      // getrefmandates();
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        typeof error.response.data === "string"
      )
        toast.error(error.response.data);

      console.log(error);
      toast("Could not process request");
    }
  };
  React.useEffect(() => {
    getrefmandates();
  }, []);
  return (
    <Container fluid>
      <Row>
        <Col md={12}>
          <Table hover responsive>
            <thead>
              <tr>
                <th />
                <th>Remita Customer Name</th>
                <th>Remita Company Name</th>

                <th>Remita Customer Id</th>
                <th>Client Id</th>
                <th>Mandate Reference</th>
                <th>Number of Repayment</th>
                <th>Repayment</th>
                <th>Total Repayment</th>
                <th>Disbursement Date</th>
                <th>Collection Date</th>
                <th />
              </tr>
            </thead>
            <tbody>
              {mandates.map((man, i) => (
                <tr key={man._id}>
                  <td>{i + 1}</td>
                  <td>{man.customerName}</td>
                  <td>{man.companyName}</td>
                  <td>{man.customerId}</td>
                  <td>
                    <span
                      style={{ color: "#007bff" }}
                      onClick={() =>
                        man.client &&
                        props.history.push(`/clientdetails/${man.client._id}`, {
                          client: man.client,
                        })
                      }
                    >
                      {man.client.clientId}
                    </span>
                  </td>
                  <td>{man.mandateReference}</td>
                  <td>{man.numberOfRepayments}</td>
                  <td>{man.repayment}</td>
                  <td>{man.totalRepayment}</td>
                  <td>{man.disbursementDate.split("T")[0]}</td>
                  <td>{man.collectionDate.split("T")[0]}</td>
                  <td>
                    <Button
                      onClick={() => checkRepayment(man._id)}
                      size="sm"
                      color="success"
                    >
                      Check Repayment
                    </Button>
                  </td>

                  <td>
                    <Button
                      disabled={man.isStopped}
                      onClick={() => stopreferencecollection(man._id)}
                      size="sm"
                      color="info"
                    >
                      Stop
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </Col>
      </Row>
    </Container>
  );
};

export default ReferenceMandates;
